import { useEffect, useState } from 'react';
import { useQuery } from '../common';

export function useNameChangeFlow() {
  const [nameChangeFlow, setNameChangeFlow] = useState(false);
  const query = useQuery();

  useEffect(() => {
    // Get state from URL
    const stateFromUrl = query.get('state');
    
    if (stateFromUrl) {
      // Check if it's a name change flow (starts with 'nameChange_')
      const isNameChange = stateFromUrl.startsWith('nameChange_');
      setNameChangeFlow(isNameChange);
    }
  }, [query]);

  return nameChangeFlow;
}
